
//variáeis de ambiente
export const Environment = {
    /**
     * Define a quantidade de linhas a ser carregada por padrão nas listagens
     */
    LIMITE_DE_LINHAS: window.innerWidth >= 1024 ? 8 : 5,
    /**
     * Placeholder exibido nas inputs
     */
    LABEL_INPUT_DE_BUSCA: 'Pesquisar',
    /**
     * Texto exibido nas inputs
     */
    PLACEHOLDER_INPUT_DE_BUSCA: 'Pesquisar...',
    /**
     * Text exibido quando nenhum registro é encontrado em uma listagem
     */
    LISTAGEM_VAZIA: 'Nenhum registro encontrado.',
    /**
     * Url base de consulta dos dados dessa aplicação
     */
    URL_BASE: process.env.NODE_ENV === 'production' 
        ? 'https://seduc.zdoc.com.br/api/' 
        : 'https://localhost:7084/',
    /**
     * Tempo padrão em milissegundos que o alert ficara aparecendo
     */
    DURACAO_ALERT: 5000,
};
